:host {
  display: block;
}
/*general*/
:root {
  --highlight-color: rgb(163, 25, 161);
}
/*ch-suggest*/
ch-suggest {
  display: block;
}
ch-suggest::part(title) {
  display: block;
  font-weight: bold;
}
ch-suggest::part(label) {
  font-weight: 500;
}
ch-suggest[label-position="start"]::part(label) {
  margin-inline-end: 8px;
  display: flex;
  align-items: center;
}
ch-suggest[label-position="above"]::part(label) {
  margin-block-end: 4px;
}
ch-suggest::part(close-button) {
  display: block;
  width: 16px;
  height: 16px;
}
ch-suggest::part(close-button)::after {
  content: "✖";
  line-height: 8px;
  height: 100%;
  display: block;
  border: 1px solid black;
  cursor: pointer;
  text-align: center;
  line-height: 16px;
}
ch-suggest::part(header) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block-end: 8px;
}
ch-suggest::part(ch-window-close) {
  width: 10px;
  height: 10px;
}
ch-suggest::part(input) {
  padding: 4px 8px;
  border: 1px solid black;
}
ch-suggest::part(input):focus {
  outline: 2px solid var(--highlight-color);
  border-color: var(--highlight-color);
}
/*ch-suggest-list*/
ch-suggest-list {
  background-color: rgba(234, 234, 234, 0.224);
  border: 1px solid rgba(128, 128, 128, 0.275);
  border-radius: 4px;
  padding: 8px;
  margin-block-end: 4px;
}
ch-suggest-list::part(title) {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  margin: 4px 0 8px 0;
}
/*ch-suggest-list-item*/
ch-suggest-list-item::part(button) {
  padding: 4px 8px;
  cursor: pointer;
  gap: 4px;
}
ch-suggest-list-item ch-icon {
  --icon-size: 16px;
  margin-inline-end: 2px;
}
ch-suggest-list-item:hover {
  background-color: var(--ch-color--violet-100);
}
ch-suggest-list-item:focus,
ch-suggest-list-item[selected]:focus {
  outline: 2px solid var(--highlight-color);
}
ch-suggest-list-item[selected] {
  background-color: rgba(241, 184, 243, 0.42);
  outline: none;
}
ch-suggest-list-item::part(button):focus {
  outline: 2px solid var(--highlight-color);
  border-color: var(--highlight-color);
}
/*content-wrapper*/
ch-suggest-list-item::part(content-wrapper) {
  display: flex;
  gap: 8px;
}
/*ch-window*/
ch-suggest::part(dropdown) {
  margin-block-start: 4px;
  border: 1px solid black;
  background-color: white;
  padding: 8px;
}
/*focus*/
:focus {
  outline-style: none !important;
}
